<script setup lang="ts">
    import { onMounted, reactive } from 'vue';
    import { bsAlert, AlertTypes } from '@shared/components/BsAlerts';
    import { getLatestSms, LatestSms } from './LatestSms.access';
    import { formatDateTime } from '@shared/utils/formatDateTime';

    const state = reactive<{
        items: LatestSms[];
        loading: boolean;
    }>({
        items: [],
        loading: false,
    });

    onMounted(async () => {
        await load();
    });

    async function load(): Promise<void> {
        state.loading = true;
        try {
            state.items = await getLatestSms();
        } catch {
            bsAlert({ type: AlertTypes.Danger, title: 'Error', content: 'Failed to load latest SMS' });
        } finally {
            state.loading = false;
        }
    }
</script>

<template>
    <h1 class="main-title">Latest sent sms</h1>
    <p>Here is the latest SMSes sent out by our customers</p>

    <div class="form-group">
        <button class="btn btn-default" :disabled="state.loading" @click="load">Refresh</button>
    </div>

    <div v-if="state.loading">Loading...</div>
    <div v-else class="table-responsive">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Sent date</th>
                    <th>Sender</th>
                    <th class="w-200">Subject</th>
                    <th class="w-300">Message</th>
                    <th class="text-right">Recipients</th>
                    <th>Last modified by</th>
                    <th>Account</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(sms, index) in state.items" :key="index">
                    <td class="text-nowrap">
                        <small>{{ sms.Ended ? formatDateTime(new Date(sms.Ended)) : 'N/A' }}</small>
                    </td>
                    <td>{{ sms.Sender }}</td>
                    <td class="text-wrap">{{ sms.Subject }}</td>
                    <td class="text-wrap">{{ sms.Body }}</td>
                    <td class="text-right">{{ sms.RecipientCount }}</td>
                    <td>{{ sms.LastModifiedByFirstName }} {{ sms.LastModifiedByLastName }}</td>
                    <td>{{ sms.AccountName }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts">
    export default {
        name: 'LatestSms',
    };
</script>

<style></style>
